import { render, staticRenderFns } from "./ModalDeleteVehicle.vue?vue&type=template&id=139aa504&scoped=true&"
import script from "./ModalDeleteVehicle.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139aa504",
  null
  
)

export default component.exports